export const submissionabstractLink = "https://forms.gle/RCovyPpHTT8XNxbF7"
export const submissionfullLink = "https://forms.gle/3yeLDdgY8MPFHx9G6"